import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[75vh] flex flex-col items-center justify-center gap-5 text-center px-6">
      <motion.div initial={{ scale: 0.5, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}>
        <XCircle size={64} className="text-[#ff007f]" data-testid="payment-cancel-icon" />
      </motion.div>
      <h1 className="font-orbitron text-2xl tracking-widest" data-testid="payment-cancel-title">
        PAGAMENTO ANNULLATO
      </h1>
      <p className="text-sm text-[#8a8a9e] max-w-[320px]">
        Nessun addebito effettuato. Puoi riprovare quando vuoi: il report rimane disponibile per la tua targa.
      </p>
      <Link
        to="/"
        data-testid="payment-cancel-back-link"
        className="bg-[#ff007f] hover:bg-[#e00070] text-white no-underline py-3 px-6 rounded-xl font-orbitron font-bold text-xs tracking-[0.15em] uppercase shadow-[0_0_20px_rgba(255,0,127,0.4)] hover:-translate-y-0.5 transition-all"
      >
        TORNA ALLA RICERCA
      </Link>
    </div>
  );
}
